import { render, staticRenderFns } from "./BatchRankOrCopyDialog.vue?vue&type=template&id=77fc864c&scoped=true&"
import script from "./BatchRankOrCopyDialog.vue?vue&type=script&lang=js&"
export * from "./BatchRankOrCopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fc864c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77fc864c')) {
      api.createRecord('77fc864c', component.options)
    } else {
      api.reload('77fc864c', component.options)
    }
    module.hot.accept("./BatchRankOrCopyDialog.vue?vue&type=template&id=77fc864c&scoped=true&", function () {
      api.rerender('77fc864c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/BatchRankOrCopyDialog.vue"
export default component.exports